import { ReactNode } from "react";
import styled, { css } from "styled-components";

const Styled = styled.div`
    background: #0001;
    border-radius: 6px;
    display: grid;
    gap: 2px;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    overflow: hidden;
    padding: 2px;
`;

interface IOptionProps {
    $selected: boolean
}

const CSSOptionSelected = css`
    background: #fff;
    box-shadow: 2px 2px 4px 0 #0001;

    &:focus-visible {
        box-shadow: none;
    }

    &:enabled {
        &:hover {
            background: #fffd;
        }

        &:active {
            background: #fffe;
            box-shadow: none;
        }
    }
`;

const Option = styled.button.attrs({ type: "button" })<IOptionProps>`
    background: transparent;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    white-space: nowrap;

    &:enabled {
        cursor: pointer;

        &:hover {
            background: #fff6;
        }

        &:active {
            background: #fff9;
        }
    }

    ${ ({ $selected }) => $selected && CSSOptionSelected }
`;

interface ISegmentedControlProps {
    disabled?: boolean
    onChange: (value: unknown) => void
    options: {
        label: ReactNode
        value: unknown
    }[]
    value: unknown
}

export default function SegmentedControl(props: ISegmentedControlProps) {
    const { disabled, onChange, options, value, ...restProps } = props;
    return (
        <Styled { ...restProps }>
            {
                options.map(
                    (option, i) => (
                        <Option
                            $selected={ option.value === value }
                            disabled={ disabled }
                            key={ i }
                            onClick={ () => onChange(option.value) }
                        >
                            { option.label }
                        </Option>
                    )
                )
            }
        </Styled>
    );
}
